// Thanks: https://github.com/regexhq/doi-regex/blob/0ac92cefde5bb9fe0d0be990388b64b3d0bb4732/index.js#L17
const doiRegExp = new RegExp('10[.][0-9]{2,}(?:[.][0-9]+)*/(?:(?![%"#? ])\\S)+');

/**
 * Returns the first DOI found in the given element (search in the text recursively).
 *
 * @param {Element} element
 * @param {Date=}   until   time at which to stop searching (5 seconds after now, if not provided)
 * @return {string|null}
 */
// @ts-expect-error FIXME
export function findDoiInElement(element, until = null) {
	const endSearchTime = until ? until : Date.now() + 5000;

	// If the time limit has passed, stop searching
	if (endSearchTime - Date.now() < 0)
		return null;

	const ignore = ["style", "script"];
	const w = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
		acceptNode(node) {
			if (node.parentElement && ignore.includes(node.parentElement.nodeName.toLowerCase()))
				return NodeFilter.FILTER_REJECT;
			return NodeFilter.FILTER_ACCEPT;
		}
	});

	while (w.nextNode()) {
		// If the time limit has passed, stop searching
		if (endSearchTime - Date.now() < 0)
			return null;

		const doi = findDoiInString(w.currentNode.textContent);
		if (doi)
			return doi;
	}

	return null;
}

/**
 * Returns the first DOI found in the given string.
 * @param {string} string
 * @return {string}|null
 */
// @ts-expect-error FIXME
export function findDoiInString(string) {
	const match = doiRegExp.exec(string);
	return match ? match[0] : null;
}
